import { createSelector } from '@ngrx/store';
import { getPatientsPageState } from '../page.reducer';
import { featureKey, selectAll } from './care.reducer';

const getState = createSelector(getPatientsPageState, (state) => state[featureKey]);

export const getLoading = createSelector(getState, (state) => state.loading);
export const getColumns = createSelector(getState, (state) => state.columns);
export const getCollection = createSelector(getState, selectAll);
